import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Typography from "@material-ui/core/Typography";
import linkRouter from "~/static/text/link";
import { withTranslation } from "~/i18n";
import { KeyboardArrowDown } from "@material-ui/icons";
import useStyles from "./header-style";

function MobileMenu(props) {
  const classes = useStyles();
  const {
    toggleDrawer,
    open,
    t,
    selectedPaymentCountry,
    onPressPayment,
  } = props;

  function renderActive(path) {
    const currentPath = window.location.pathname;
    if (path === currentPath) {
      return classes.menuText;
    }
    return null;
  }

  // function renderPaymentCountry() {
  //   if (selectedPaymentCountry) {
  //     return (
  //       <div
  //         className={classes.ctnMobileCountry}
  //         onClick={onPressPayment}
  //         onKeyDown={onPressPayment}
  //         role="button"
  //         tabIndex={0}
  //       >
  //         <img src={selectedPaymentCountry.source} alt="flag" />
  //         <Typography className={classes.txtMenuCountry}>
  //           {selectedPaymentCountry.key === "SG"
  //             ? t("myfitsociety:singapore")
  //             : selectedPaymentCountry.title}
  //         </Typography>
  //         <KeyboardArrowDown className={classes.arrowIcon} />
  //       </div>
  //     );
  //   }
  //   return null;
  // }

  const SideList = () => (
    <div
      className={classes.mobileNav}
      role="presentation"
      onClick={toggleDrawer}
      onKeyDown={toggleDrawer}
    >
      <div className={clsx(classes.menu, open && classes.menuOpen)}>
        {/* <List component="nav">
          {navMenu.map((item, index) => (
            <ListItem
              button
              component="a"
              href={`#${item}`}
              key={item}
              index={index.toString()}
              style={{ animationDuration: index * 0.15 + 's' }}
            >
              <ListItemText
                primary={t('mobile-landing:header_' + item)}
                className={classes.menuList}
              />
            </ListItem>
          ))}
          <ListItem
            button
            component="a"
            href={linkRouter.mobile.contact}
            style={{ animationDuration: navMenu.length * 0.15 + 's' }}
          >
            <ListItemText
              primary={t('mobile-landing:header_contact')}
              className={classes.menuList}
            />
          </ListItem>
        </List> */}
        <div className={clsx(classes.menuSection, classes.topMenuSection)}>
          <div className={classes.menuInner}>
            <a href="/">
              <Typography
                className={clsx(classes.menuItemText, renderActive("/"))}
              >
                {t("home")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.articleCategory("fatloss")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.articleCategory("fatloss")),
                )}
              >
                {t("fatlossDefault")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.articleCategory("workouts")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.articleCategory("workouts")),
                )}
              >
                {t("workoutDefault")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.articleCategory("nutrition")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.articleCategory("nutrition")),
                )}
              >
                {t("nutritionDefault")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.articleCategory("healthy-living")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(
                    linkRouter.mobile.articleCategory("healthy-living"),
                  ),
                )}
              >
                {t("healthy_livingDefault")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.articleCategory("personal-development")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(
                    linkRouter.mobile.articleCategory("personal-development"),
                  ),
                )}
              >
                {t("personal_developmentDefault")}
              </Typography>
            </a>
          </div>
        </div>
        <div className={classes.separator} />
        <div className={classes.menuSection}>
          <div className={clsx(classes.menuInner, classes.menuHasMargin)}>
            <a href={linkRouter.mobile.static("about")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("about")),
                )}
              >
                {t("about_us")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.static("privacy-policy")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("privacy-policy")),
                )}
              >
                {t("privacy_policy")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.static("terms-of-use")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("terms-of-use")),
                )}
              >
                {t("terms_of_use")}
              </Typography>
            </a>
            {/* Trello 585 (13 OCT 2026): same legal trio the footer already links
                — refund-policy, Washington (consumer-health-data-privacy) and
                Nevada health data policies. */}
            <a href={linkRouter.mobile.static("refund-policy")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("refund-policy")),
                )}
              >
                {t("refund_policy")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.static("consumer-health-data-privacy")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("consumer-health-data-privacy")),
                )}
              >
                {t("washington_health_data_policy")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.static("nevada-health-data-policy")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("nevada-health-data-policy")),
                )}
              >
                {t("nevada_health_data_policy")}
              </Typography>
            </a>
            <a href={linkRouter.mobile.static("contact-us")}>
              <Typography
                className={clsx(
                  classes.menuItemText,
                  renderActive(linkRouter.mobile.static("contact-us")),
                )}
              >
                {t("contact_us")}
              </Typography>
            </a>
            {/* {renderPaymentCountry()} */}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <SwipeableDrawer
      open={open}
      onClose={toggleDrawer}
      onOpen={toggleDrawer}
      classes={{
        paper: classes.paperNav,
      }}
    >
      <SideList />
    </SwipeableDrawer>
  );
}

MobileMenu.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation(["myfitsociety"])(MobileMenu);
